import { Component, OnInit, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ScriptService } from './script';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  isLoading: boolean = false

  constructor(
    private scriptService: ScriptService,
    private renderer: Renderer2,
  ) { 
    console.log("deploy");
    
  }

  ngOnInit(): void {
    const pciUrl = this.scriptService.loadJsScript(this.renderer, environment.pci_proxy_url)

    pciUrl.onload = () => {
      this.callback()
    }

    // El checkout de Yuno carga su propia version del SDK: tener las dos en window.Yuno rompe la que
    // se cargue segunda con "Cannot access 'E' before initialization".
    if (location.pathname.startsWith('/yuno/')) {
      return
    }

    const yunoUrl = this.scriptService.loadJsScript(this.renderer, environment.yuno_sdk)

    yunoUrl.onload = () => {
      this.callback()
    }
  }

  callback() {
    setTimeout(() => {
      this.isLoading = true
    }, 500);
  }
}
